import React from 'react'
import Logo from '@assets/images/staffModalIcon.svg?url'
import { makeStyles } from '@mui/styles'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

const useStyles = makeStyles(() => ({
  logo: {
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

const MissingStaffDataRight: React.FC = () => {
  const classes = useStyles()
  return (
    <div className={classes.logo}>
      <SVGIcon svg={Logo} />
    </div>
  )
}

export default MissingStaffDataRight
